export default __webpack_public_path__ + "static/media/exit.a97f75ee.svg";